export default function getFirstName(fullname: string): string | undefined {
  return fullname && fullname.split(' ').shift();
}
